import { AppHelper } from "../appHelper";
import { Config } from "../core/config/config";
import { Helper } from "../core/util/helper";
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp";
import { PageTitleProps } from "../core/components/pageTitle";
import React from "react";
export default class IntegrationProtocol extends React.Component<IntegrationProtocolProps, IntegrationProtocolState>{
    private lockId: number;
    common = new AppHelper();
    deleteEnabled = false;
    isDeleted = false;
    currentUrl: string = null;
    translations: {};
    //schaltet den Browsertab-Titel an; wird von common aufgerufen
    setTabTitle = true;
    keyTypes = ['ADRESSE', 'PROJEKT', 'TICKET', 'KONTAKT', 'RESSOURCE', 'MASCHINE', 'ARTIKEL', 'EINSATZ', 'BELEG'];
    
    
    


    constructor(props: IntegrationProtocolProps) {
        super(props);
        this.common.init(this);
        this.initApp();
    }


    private initApp = async () => {
    }


    componentDidMount() {
    }
    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: () => { } });
        const titleProps: PageTitleProps = {
            title: "",
            value: "",
            locked: false,
            lockInfo: ""
        };
        return <CommonApp {...props} titleProps={titleProps} />;
    }
};
export interface IntegrationProtocolProps extends AppBaseProps {
    entity: EntityIntegrationProtocol;
}
interface IntegrationProtocolState {
}
export interface EntityIntegrationProtocol extends Entity {
    ID: string;
    DateTimeStamp: Date;
    System: string;
    Level: number;
    Area: string;
    Code: string;
    Content: string;
    Description: string;
    ContextKey: string;
    KeyType: string;
    PrimaryIdentifier: string;
    SecondaryIdentifier: string;
    FSMUser: string;
}